<template>
    <div class="body">
        <div v-for="(obj, index) in dataItensAPR" v-bind:key="index" style="align-items: center;">
          <b-card no-body class="font-column-matriz-etapa" style="border: none; margin-bottom: 0rem; margin-top: 1rem; display: flex; justify-content: center; align-items: flex-start; border-radius: 0;">
            <div  style="width: 100%;">
              <b-card-header v-on:click="toggleSection(index)" header-tag="header" class="w-100 p-0 mb-0 collapseApr" role="tab">
                <div  variant="info" class="head-mes">
                  <div class="title-left pl-3">
                  <div class="title-colapse-mirror">{{ obj.nome }}</div>
                  </div>
                  <div class="componente" style="padding: 0 10px 0 10px;">
                  <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel"></i>
                  <i v-else class="fas fa-angle-up arrow-angel"></i>
                  </div>
              </div>
              </b-card-header>
            </div>
            <b-collapse
              :visible="openSections.includes(index)"
              id="id"
              role="tabpanel"
              ref="testeacor"
              class="w-100"
              style="margin-bottom: 0;">
             <div v-for="(itensCadastro,index) in obj.itens" v-bind:key="index">
                <div class="itensAPR">
                    {{ itensCadastro[fieldMapping[obj.nome]] }}
                </div>
             </div>
            </b-collapse>
          </b-card>
        </div>
    </div>
  </template>

<script>
import aprItemDetails from './aprItemDetails'
export default aprItemDetails
</script>

    <style scoped>
    .itensAPR {
        color: #666666;
        padding: 0.5rem;
        font-family: 'Segoe UI';
        border-left: 1px solid #d2d2d2;
        border-right: 1px solid #d2d2d2;
        border-bottom: 1px solid #d2d2d2;

    }
    .head-mes {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding-right: 1rem;
    }
    .collapseApr {
      background-color: #008144;
      min-height: 2rem; /* Altura mínima de 2rem */
      height: fit-content; /* Ajusta a altura ao conteúdo */
      display: flex;
      border-radius: 0;
      width: 100%;
    }
    .pageBreak {
      /* break-after: avoid;
      break-before: avoid; */
      break-inside: avoid;
    }
    .button-novo-risco{
      font: normal normal 600 12px/24px Segoe UI;
      font-weight: bold;
    }
    .img_sem_risco{
      width: 24%;
      margin: 3rem;
    }
    .container_img_sem_risco{
      display: flex;
      padding: 1rem;
      justify-content: center;
    }
    .barra {
      border-left: 1px solid #d2d2d2;
      height: 2rem;
      margin: 0 10px 0 10px;
    }
    .Coluna-Detalhes-Resultado-Risco-parte3 {
      display: flex;
      justify-content: center;
      width: 10%;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-Resultado-Risco-parte1 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-Resultado-Risco-parte2 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .icone-novo-risco{
      display: flex;
      align-items: center;
      font-size: 10px;
      padding-right: 6px;
    }
    .icone-lixeira{
      font-size: 10px;
    }
    .Coluna-Detalhes-risco{
      border: 1px solid #d2d2d2;
      display: flex;
      width: 100%;
      height: 2rem;
      background-color: #f5f5f5;
    }
    .Coluna-Detalhes-risco-parte1 {
      display: flex;
      justify-content: flex-start;
      width: 75%;
      align-items: center;
      padding-left: 0.5rem;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-risco-parte2 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
      background-color: #e4e5e6;
    }
    .Coluna-Detalhes-risco-parte3 {
      display: flex;
      width: 10%;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .body{
      width: 100%;
    }
    .container-apr{
      /* break-before: avoid; */
      margin-bottom: 1rem;
    }
    .riscos-container{
      border: 1px solid #d2d2d2;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .border-meio-div{
      border-left: 1px solid #d2d2d2;
    }
    .border-riscos {
      display: flex;
      height: 3.5rem;
      align-items: center;
    }
    .risco-font-detalhe{
      color: #008144;
      font-family: 'Segoe UI';
      font-size: 14px;
      padding: 0 0 0 8px;
      width: fit-content;
    }
    .tag{
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-radius: 20px;
      height: 100%;
    }
    .tag_identintificacao{
      width: fit-content;
      height: 1.6rem;
      text-align: center;
      border-radius: 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      padding: 0 5px 0 5px;
      font-weight: bold;
    }
    .header-title{
      color: white;
      font-weight: bold;
      font-size: 16px;
      font-family: 'Segoe UI';
    }
    .icone-edicao-risco{
      display: flex;
      cursor: pointer;
      justify-content: end;
    }
    .icone-visualizacao-risco{
      display: flex;
      cursor: pointer;
      justify-content: end;
      scale: 1.5
    }
    .Header-Detalhes-Templete{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 2rem;
      background-color: #e4e5e6;
      border-right: 1px solid #c9c9c9;
    }
    .Colunas-Detalhes-template{
      align-items: center;
      justify-content: center;
      display: flex;
      width: 100%;
      height: 2rem;
    }
    .Informacao-Detalhes-template{
      display: flex;
      border: 1px solid #c9c9c9;
      justify-content: initial;
      align-items: center;
      width: 100%;
      height: fit-content;
    }
    .Informacao-Detalhes-template-pdf{
      display: flex;
      flex-direction: column;
      gap: 1rem;
      border: 1px solid #c9c9c9;
      justify-content: initial;
      align-items: flex-start;
      width: 100%;
      height: fit-content;
    }
    .detalhe-pdf{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
    .font-column{
      font-size: 12px;
      color: #008144;
      font-family: 'Segoe UI';
      font-weight: bold;
    }
    .font-column-matriz{
    font-size: 12px;
    /* background-color: #008144; */
    color: #666666;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: center;
  }
    .font-column-matriz-etapa{
    font-size: 16px;
    /* background-color: #008144; */
    color: white;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
  }
  .font{
        color: #666666;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .tipo-apr{
      color:#666666;
      width: 100%;
    }
    .add{
      width: 20%;
      cursor: pointer;
      display: flex;
      justify-content: end;
    }
    .exclur{
      width: 3%;
      cursor: pointer;
      display: flex;
      justify-content: end;
      align-items: center;
      color: white;
    }
    .card-container{
      display: flex;
      border-left: 1px solid #d2d2d2;
      align-items: center;
      height: 3.5rem;
      column-gap: 0.5rem;
      padding: 0 1rem;
    }
    .font-bold {
      font-size: 14px;
      font-weight: bold;
      color:#666666;
    }
    .cursor {
      cursor: pointer;
    }
    .card-apr{
      font-size: 12px;
      font-family: 'Segoe UI';
      border-radius: 5px;
      width: 2.2rem;
      height: 2.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .card1{
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .icones {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .font_result {
        color: #1A1818;
        font-family:'Segoe UI';
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/details/components/aprItemDetails/aprItemDetails.vue